export const formatDate = (date:Date) => {
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2); // Months are 0-based
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };

export const mindate = () => {
    const today = new Date();
    return formatDate(today);
};
 
export const maxdate = (scheduleDays:number) => {
    const today = new Date();
    today.setDate(today.getDate() + scheduleDays);
    return formatDate(today);
};

export const timeSlotString =  (timeslot:string, durationInMinutes:number) => {
    const [startHour, startMinutes] = timeslot.split(':').map(Number);
    const endTime = new Date();
    endTime.setHours(startHour, startMinutes + durationInMinutes, 0);

    const endHour = endTime.getHours();
    const endMinutes = endTime.getMinutes();
  
    return `${startHour}-${startMinutes}-${endHour}-${endMinutes}`;
}

export const combineDateTime = (timeslot:string, date:string) => {
    if (!timeslot || !date) {
      return '';
    }
    const formattedDate = date.split('-').reverse().join('-');
    return `${formattedDate}-${timeslot}`;
};

export const getDatesInRange = (from: string, to: string): string[] => {

  const startDate = new Date(from);
  const endDate = new Date(to);
  const dates: string[] = [];
  for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
    dates.push(date.toISOString().split('T')[0]);
  }

  return dates;
}